// mb-cart: the source's "Your order" side drawer on real cart data (cart.js endpoint).
// Opens after Add to cart (mb-buy.js calls MBCart.open). Quantity steps between the buy box's tier quantities (1, 3, 5),
// Upgrade jumps to the next tier, Remove sets 0. One mutation at a time; every response re-renders from the server cart.
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var el = document.getElementById('mb-cart-drawer');
  if (!el) return;
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', class extends HTMLElement { close() { MBCart.close(); } open() { MBCart.open(); } });
  var lines = el.querySelector('.mcd-lines');
  var tpl = el.querySelector('.mcd-line'); if (tpl) tpl.remove();
  var errEl = el.querySelector('.mcd-err');
  var busy = false, cart = null;
  function txt(sel, v, scope) { var n = (scope || el).querySelector(sel); if (n) n.textContent = v; return n; }
  function money(c) {
    var fmt = (window.MB_BUY && MB_BUY.moneyFormat) || '${{amount}}', n = c / 100;
    function g(x, d, t, s) { var p = x.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return p.join(s); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) { return k.indexOf('comma') > -1 ? g(n, k.indexOf('no_decimals') > -1 ? 0 : 2, '.', ',') : g(n, k.indexOf('no_decimals') > -1 ? 0 : 2, ',', '.'); });
  }
  // per-unit strike for a variant: its compare-at, else the buy box's display rule (2× price, or the tier's strike setting)
  function unitCompare(item) {
    var v = window.MB_BUY && MB_BUY.variants[String(item.variant_id)];
    if (v && v.compare && v.compare > v.price) return v.compare;
    return item.original_price * 2;
  }
  function tierQtys() {
    var q = (window.MB_BUY ? MB_BUY.tiers.filter(function (t) { return t.on; }).map(function (t) { return Math.max(1, parseInt(t.qty, 10) || 1); }) : [1, 3, 5]);
    return q.filter(function (x, i) { return q.indexOf(x) === i; }).sort(function (a, b) { return a - b; });
  }
  function next(q) { var t = tierQtys(); for (var i = 0; i < t.length; i++) if (t[i] > q) return t[i]; return null; }
  function prev(q) { var t = tierQtys(); for (var i = t.length - 1; i >= 0; i--) if (t[i] < q) return t[i]; return null; }
  var labels = {};   // the merchant's wording around the numbers (from the section settings, first render)
  function grab(sel) { var n = el.querySelector(sel); return n ? n.textContent : ''; }
  labels.per = grab('.mcd-per-unit').replace(new RegExp('^\\S*\\d[\\d.,]*\\s*'), '') || 'per pack';
  labels.cta = (grab('.mcd-cta-label').split('·')[0] || 'Secure checkout').trim();

  function render(c) {
    cart = c; lines.innerHTML = '';
    if (!c.items.length) { MBCart.close(); return; }
    var sub = 0;
    c.items.forEach(function (it) {
      var n = tpl.cloneNode(true); n.setAttribute('data-key', it.key);
      var img = n.querySelector('.mcd-thumb'); if (img && it.image) { img.src = it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160'; img.removeAttribute('srcset'); }
      txt('.mcd-line-name', it.product_title, n);
      txt('.mcd-qty', it.quantity, n);
      txt('.mcd-per-unit', money(it.final_price) + ' ' + labels.per, n);
      var uc = unitCompare(it); sub += uc * it.quantity;
      var pct = uc > 0 ? Math.round(100 - it.final_price * 100 / uc) : 0;
      var badge = txt('.mcd-save-badge', '−' + pct + '%', n); if (badge) badge.hidden = pct <= 0;
      n.querySelectorAll('[data-dir],[data-mcd-remove]').forEach(function (b) { b.setAttribute('data-key', it.key); });
      var down = n.querySelector('[data-dir="down"]'); if (down) down.disabled = false;
      lines.appendChild(n);
    });
    // upgrade = the next tier for the first line
    var it0 = c.items[0], up = el.querySelector('.mcd-upgrade'), nq = next(it0.quantity);
    if (up) {
      up.hidden = !nq;
      if (nq) {
        var add = nq - it0.quantity, unit = it0.final_price, addPrice = unit * add;
        var head = up.querySelector('.mcd-upgrade-head');
        if (head) head.textContent = '+' + add + ' packs for ' + money(addPrice) + ' — ' + money(unit) + ' each';
        var save = up.querySelector('.mcd-upgrade-save'); if (save) save.hidden = true;   // flat per-pack price: no per-pack saving to show until tier variants/discounts exist
        var ub = up.querySelector('.mcd-upgrade-btn'); if (ub) { ub.setAttribute('data-key', it0.key); ub.setAttribute('data-to', nq); }
      }
    }
    var total = c.total_price;
    txt('.mcd-row-subtotal span:last-child', money(sub));
    var sv = el.querySelector('.mcd-row-savings'); if (sv) { sv.hidden = sub - total <= 0; txt('.mcd-row-savings span:last-child', '−' + money(sub - total)); }
    txt('.mcd-total-val', money(total));
    txt('.mcd-cta-label', labels.cta + ' · ' + money(total));
  }
  function fail(m) { if (errEl) { errEl.textContent = m; errEl.hidden = false; } }
  function change(key, q) {
    if (busy) return; busy = true; el.classList.add('is-busy'); if (errEl) errEl.hidden = true;
    fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || !j.items) throw new Error(j.description || 'error'); return j; }); })
      .then(render).catch(function (e) { fail((window.MB_BUY && MB_BUY.msg.failed) || 'Something went wrong.'); })
      .then(function () { busy = false; el.classList.remove('is-busy'); });
  }
  el.addEventListener('click', function (e) {
    var b = e.target.closest('[data-dir],[data-mcd-remove]'); if (!b || !cart) return;
    var key = b.getAttribute('data-key'), it = cart.items.filter(function (i) { return i.key === key; })[0]; if (!it) return;
    e.preventDefault();
    if (b.hasAttribute('data-mcd-remove')) return change(key, 0);
    var d = b.getAttribute('data-dir');
    if (d === 'up' || d === 'upgrade') { var n = next(it.quantity); change(key, n || it.quantity + 1); }
    else if (d === 'down') { var p = prev(it.quantity); if (p) change(key, p); else change(key, 0); }
  });
  var ov = el.querySelector('.cart-drawer__overlay'); if (ov) ov.addEventListener('click', function () { MBCart.close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('active')) MBCart.close(); });
  var lastFocus = null;
  window.MBCart = {
    open: function () {
      lastFocus = document.activeElement;
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        render(c); if (!c.items.length) return;
        el.classList.remove('is-empty'); el.classList.add('animate', 'active'); document.body.classList.add('overflow-hidden');
        var f = el.querySelector('.drawer__close'); if (f) setTimeout(function () { f.focus(); }, 50);
      });
    },
    close: function () { el.classList.remove('active'); document.body.classList.remove('overflow-hidden'); if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  };
  window.addEventListener('pageshow', function (e) { if (e.persisted) MBCart.close(); });
  // header cart icon opens the drawer when it has items
  document.querySelectorAll('#cart-icon-bubble, a[href$="/cart"]').forEach(function (a) {
    a.addEventListener('click', function (e) { if (!window.MBCart) return; e.preventDefault(); MBCart.open().then(function () { if (!cart || !cart.items.length) location.href = root + 'cart'; }); });
  });
})();
